export const JOBSBENEFITS = [
    'Valuable work experience that will last a lifetime',
    'Generous benefits and insurance packages',
    'Unlimited visits to the park for yourself',
    'Limited number of free guest passes',
    'Discount on all Cafe and Gift Shop purchases',
    'Making new friends from around the world',
]